<template>
    <b-container fluid class="filtroEmpresas">
        <!-- Filtros -->
        <el-tabs type="border-card">
            <el-tab-pane>
                <span slot="label"><i class="fa fa-building"></i> Empresas</span>
                <b-row>
                    <div class="col-lg-12 col-md-12 mt-2">
                        <container-card id="filtrosPesquisarEmpresa" icon="fa-filter" title="Selecione as opções de pesquisa.">
                            <el-form :model="model" ref="formPesquisarEmpresas" size="mini" label-position="top">
                                <b-card>
                                    <b-form-row>
                                        <div class="col-lg-9 col-md-9">
                                            <SelectMarcas v-model="model.marcas" />
                                        </div>
                                        <div class="col-lg-3 col-md-3">
                                            <el-form-item label="Status:" label-for="status" class="select-status">
                                                <el-select class="w-100" size="small" v-model="model.ativo" clearable placeholder="Todos">
                                                    <el-option
                                                        label="Ativo"
                                                        :value="true">
                                                    </el-option>
                                                    <el-option
                                                        label="Inativo"
                                                        :value="false">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </div>
                                    </b-form-row>
                                    <b-form-row class="mb-2">
                                        <div class="col-lg-4 col-md-4">
                                            <el-form-item :label="`Empresa${model.clusterEmpresaBool ? ' (Cluster)' : ''}:`" label-for="razaoSocial" :prop="model.clusterEmpresaBool ? 'clustersEmpresasIds' : 'razaoSocial'">
                                                <div class="toogle-multiselect-cluster">
                                                    <small class="label-toogle-cluster">{{ model.clusterEmpresaBool ? 'Alterar para empresas' : 'Alterar para cluster' }}&nbsp;&nbsp;</small>
                                                    <el-switch v-b-popover.hover.top="'Alternar combo clusters/empresas.'"
                                                                v-model="model.clusterEmpresaBool"></el-switch>
                                                </div>
                                                <div v-show="model.clusterEmpresaBool == false">
                                                    <b-form-input size="sm" id="razaoSocial" v-model="model.razaoSocial" placeholder="Razão Social" />
                                                </div>
                                                <div v-show="model.clusterEmpresaBool == true">
                                                    <select2-multiple :options="listas.cluster" name="empresasACluster" v-model="model.clustersEmpresasIds" :url="$urls.DRE_LISTA_CLUSTER"></select2-multiple>
                                                </div>
                                            </el-form-item>
                                        </div>
                                        <div class="col-lg-4 col-md-4">
                                            <el-form-item :label="'Apelido:'" label-for="nickname">
                                                <b-form-input :disabled="clusterHabilitado" size="sm" id="nickname" v-model="model.nickname" placeholder="Apelido" />
                                            </el-form-item>
                                        </div>
                                        <div class="col-lg-4 col-md-4">
                                            <el-form-item :label="'Nome Fantasia:'" label-for="nomeFantasia">
                                                <b-form-input :disabled="clusterHabilitado" size="sm" id="nomeFantasia" v-model="model.nomeFantasia" placeholder="Nome Fantasia" />
                                            </el-form-item>
                                        </div>
                                    </b-form-row>
                                    <b-form-row class="mb-2">
                                        <div class="col-lg-4 col-md-4">
                                            <el-form-item :label="'Grupo:'" label-for="nomeGrupo">
                                                <b-form-input :disabled="clusterHabilitado" size="sm" id="nomeGrupo" v-model="model.nomeGrupo" placeholder="Grupo" />
                                            </el-form-item>
                                        </div>
                                        <div class="col-lg-4 col-md-4">
                                            <el-form-item :label="'Código do grupo:'" label-for="codigoGrupo">
                                                <b-form-input :disabled="clusterHabilitado" size="sm" id="codigoGrupo" v-model="model.codigoGrupo" placeholder="Código do grupo" />
                                            </el-form-item>
                                        </div>
                                        <div class="col-lg-4 col-md-4">
                                            <el-form-item :label="'Código da loja:'" label-for="codigoLoja">
                                                <b-form-input :disabled="clusterHabilitado" size="sm" id="codigoLoja" v-model="model.codigoLoja" placeholder="Código da loja" />
                                            </el-form-item>
                                        </div>
                                    </b-form-row>
                                    <b-form-row>
                                        <div class="col-lg-3 col-md-4">
                                            <el-form-item :label="'Tipo de Estabelecimento:'" label-for="tipoDeEstabelecimento">
                                                <select2-multiple :disabled="clusterHabilitado" name="tipoDeEstabelecimento" :url="$urls.CLUSTER_TIPO_ESTABELECIMENTO" :options="listas.tipoDeEstabelecimento" v-model="model.tipoDeEstabelecimento"></select2-multiple>
                                            </el-form-item>
                                        </div>
                                        <div class="col-lg-3 col-md-4">
                                            <el-form-item :label="'Local do Estabelecimento:'" label-for="localEstabelecimento">
                                                <select2-multiple :disabled="clusterHabilitado" name="localEstabelecimento" :url="$urls.CLUSTER_LOCAL_ESTABELECIMENTO" :options="listas.localEstabelecimento" v-model="model.localEstabelecimento"></select2-multiple>
                                            </el-form-item>
                                        </div>
                                        <div class="col-lg-3 col-md-4">
                                            <el-form-item :label="'Estado:'" label-for="estado">
                                                <select2-multiple :disabled="clusterHabilitado" :hasUpdate="true" :urlExterna="$urls.CLUSTER_ESTADOS" :options="listas.estados" text="sigla" name="estadoFiltroSelect" v-model="model.codigoEstado"></select2-multiple>
                                            </el-form-item>
                                        </div>
                                        <div class="col-lg-3 col-md-4">
                                            <el-form-item  :label="'Cidade:'" label-for="cidade">
                                                <select2-multiple :disabled="habilitarCidade" :hasUpdate="true" :urlExterna="$urls.CLUSTER_CIDADES" :options="listas.cidades" text="nome" name="cidadeFiltroSelect" v-model="model.codigoCidade"></select2-multiple>
                                            </el-form-item >
                                        </div>
                                    </b-form-row>
                                    <div slot="footer">
                                        <div class="float-left btn-pesquisar" v-if="temAcesso('Empresa','Obter')">
                                            <b-button style="width:100px;" @click.prevent="pesquisarEmpresas" variant="primary" size="sm" class="mr-2">Pesquisar</b-button>
                                            <b-button style="width:100px;" @click.prevent="limpar" size="sm" class="mr-2">Limpar</b-button>
                                        </div>
                                        <div class="float-left btn-pesquisar" title="Sem permissões" v-else>
                                            <b-button style="width:100px;" disabled size="sm" class="mr-2 no-drop">Pesquisar</b-button>
                                        </div>

                                        <div class="float-right btn-exportar">
                                            <el-popover
                                                v-if="temAcesso('Empresa','Exportar')"
                                                placement="bottom"
                                                width="230"
                                                v-model="gerarRelatorioVisivel">
                                                <p>Deseja gerar um relatório com as informações de Empresas?</p>
                                                <div style="text-align: right; margin: 0">
                                                    <el-button size="mini" type="text" @click="gerarRelatorioVisivel = false">Não</el-button>
                                                    <el-button type="primary" size="mini" @click="exportarRelatorioDeEmpresas">Sim</el-button>
                                                </div>
                                                <el-button style="width:100px;" type="success" slot="reference" size="small" :disabled="exportarDisabled">
                                                    <i class="fas fa-file-export"></i> 
                                                    Exportar 
                                                </el-button>
                                            </el-popover>
                                            <el-button lcass="float-right" style="width:100px;" title="Sem permissões" size="small" disabled v-else>
                                                <i class="fas fa-file-export"></i> 
                                                Exportar 
                                            </el-button>
                                        </div>
                                    </div>
                                </b-card>
                            </el-form>
                        </container-card>
                        <div
                            v-loading="loading"
                            v-if="loading"
                            class="loading"
                        />
                        <EmpresasTable
                            :empresasResponse="empresasResponse"
                            :filters="model"
                            @modelAlterado="alterarPaginacao($event)"
                            v-else
                        />
                    </div>
                </b-row>
            </el-tab-pane>
            <el-tab-pane>
                <span slot="label"><i class="fa fa-cogs"></i> Centros de Custos</span>
                <CentroCustosContainer />
            </el-tab-pane>
        </el-tabs>
    </b-container>
</template>

<script>
import ContainerCard from '@/components/shared/ContainerCard'
import Select2Multiple from '@/components/shared/Select2Multiple'
import EmpresasTable from '@/views/Empresas/EmpresasTable'
import SelectMarcas from '@/components/shared/SelectMarcas'
import CentroCustosContainer from '@/views/Empresas/modules/CentrosCustos/CentrosCustosContainer'

const listas = () => {
    return {
        empresas: [],
        cluster: [],
        tipoDeEstabelecimento: [],
        localEstabelecimento: [],
        estados: [],
        cidades: [],
    }
}

const model = () => {
    return {
        page: 1,
        pageSize: 25,
        razaoSocial: '',
        nickname: '',
        nomeFantasia: '',
        clusterEmpresaBool: false,
        clustersEmpresasIds: [],
        tipoDeEstabelecimento: [],
        localEstabelecimento: [],
        codigoEstado: [],
        codigoCidade: [],
        marcas: [],
        codigoGrupo: '',
        nomeGrupo: '',
        codigoLoja: '',
        sort: '',
        order: '',
        ativo: null
    }
}

export default {
    components: {
        ContainerCard,
        Select2Multiple,
        EmpresasTable,
        SelectMarcas,
        CentroCustosContainer
    },
    name: 'empresas',
    data() {
        return {
            gerarRelatorioVisivel: false,
            exportarDisabled: false,
            loading: false,
            model: model(),
            listas: listas(),
            empresasResponse: { }
        }
    },
    methods: {
        limpar() {
            this.model = model();
            this.empresasResponse = { }
        },
        pesquisarEmpresas() {
            this.loading = true;

            this.$refs['formPesquisarEmpresas'].validate((valid) => {
                if (!valid) {
                    this.loading = false
                    return false;
                }

                this.listarEmpresas(this.model);
            });
        },
        async listarEmpresas(pesquisa) {

            const response = await this.axios.get(this.$urls.LISTAR_EMPRESAS, {
                params: {
                    page: pesquisa.page,
                    pageSize: pesquisa.pageSize,
                    razaoSocial: pesquisa.razaoSocial,
                    nickname: pesquisa.nickname,
                    nomeGrupo: pesquisa.nomeGrupo,
                    nomeFantasia: pesquisa.nomeFantasia,
                    clustersEmpresasIds: pesquisa.clustersEmpresasIds.toString(),
                    codigoGrupo: pesquisa.codigoGrupo,
                    codigoLoja: pesquisa.codigoLoja,
                    tipoDeEstabelecimento: pesquisa.tipoDeEstabelecimento.toString(),
                    localEstabelecimento: pesquisa.localEstabelecimento.toString(),
                    codigoEstado: pesquisa.codigoEstado.join(';'),
                    codigoCidade: pesquisa.codigoCidade.join(';'),
                    sort: pesquisa.sort,
                    order: pesquisa.order,
                    marcas: pesquisa.marcas.join(';'),
                    ativo: pesquisa.ativo !== null && pesquisa.ativo !== undefined ? pesquisa.ativo : null
                },
            });
            
            if (response.status !== 200){
                this.logErro();
                this.loading = false;
                return;
            }
            
            this.empresasResponse = response.data;
            this.loading = false;
        },
        alterarPaginacao(modelAtualizado) {
            this.model = modelAtualizado;
            this.pesquisarEmpresas();
        },
        exportarRelatorioDeEmpresas() {
            this.requestExportarRelatorio();
            this.gerarRelatorioVisivel = false;
        },
        async requestExportarRelatorio() {
            const modelRequest = {
                razaoSocial: this.model.razaoSocial,
                nickname: this.model.nickname,
                nomeGrupo: this.model.nomeGrupo,
                nomeFantasia: this.model.nomeFantasia,
                clustersEmpresasIds: this.model.clustersEmpresasIds.toString(),
                codigoGrupo: this.model.codigoGrupo,
                codigoLoja: this.model.codigoLoja,
                tipoDeEstabelecimento: this.model.tipoDeEstabelecimento.toString(),
                localEstabelecimento: this.model.localEstabelecimento.toString(),
                codigoEstado: this.model.codigoEstado.join(';'),
                codigoCidade: this.model.codigoCidade.join(';'),
                sort: this.model.sort,
                order: this.model.order,
                ativo: this.model.ativo !== null && this.model.ativo !== undefined ? this.model.ativo : null
            }
            let request = await this.axios.post(this.$urls.EXPORTAR_EMPRESAS, modelRequest);

            if(request.status !== 200) {
                this.$message.error('Algum erro interno aconteceu, por favor consulte nosso suporte.');
                return;
            }

            this.$notify({
                type: "success",
                title: 'Gerando Relatório',
                dangerouslyUseHTMLString: true,
                message: `Sua solicitação de relatório foi enviada, por favor verifique a tela de <a href="/#/relatorio" target="_blank">relatórios</a>`
            });

            this.exportarDisabled = false;
        },
        limparClusterHabilitado() {
            this.model.nickname = '';
            this.model.nomeGrupo = '';
            this.model.nomeFantasia = '';
            this.model.codigoGrupo = '';
            this.model.codigoLoja = '';
            this.model.tipoDeEstabelecimento = [];
            this.model.localEstabelecimento = [];
            this.model.codigoEstado = [];
            this.model.clustersEmpresasIds = [];
        }
    },
    computed: {
        habilitarCidade() {
            return this.model.codigoEstado.length ? false : true
        },
        clusterHabilitado() {
            this.limparClusterHabilitado();
            return this.model.clusterEmpresaBool;
        }
    },
    watch: {
        'model.codigoEstado': function(val) {
            let estados = val
            
            if (estados.length <= 0){
                return false
            }

            const cidadePorEstado = () => {
                return `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${Array.isArray(estados) ? estados.join('|') : ''}/municipios`
            }

            this.model.codigoCidade = [];
            
            this.axios.get(cidadePorEstado()).then((dt) => {
                this.listas.cidades = dt.data;
            }).catch((err) => {
                alert(err)
            })
        }
    },
}
</script>

<style>
.filtroEmpresas .toogle-multiselect-cluster {
    top: -31px;
    position: absolute;
    right: 0;
}
.filtroEmpresas .el-form--label-top .el-form-item__label {
    padding: 0 0 0;
}
.filtroEmpresas div span.select2-container .select2-search--inline .select2-search__field {
    margin: 0px 5px !important;
}
.loading {
  height: 10vh;
}
.font-size-small {
    font-size: 14px;
}

.select-status .el-form-item__label {
    line-height: 22px !important;
}
</style>